<template>
  <div>
    <el-card class="box-card">
      <el-form :model="editFormchailvfei" ref="editFormchailvfei" label-width="170px">
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差事由(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.reason"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差日期起(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.ccdaybegin"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">出差日期讫(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.ccdayend"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">总天数(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.ccdays"></el-input>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">附件张数(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.ccattachmentnum"></el-input>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <label slot="label">
            <span style="color: #FF0000;">填写明细(必填)</span>
          </label>
          <div class="productdata1">
            <div class="productdata2">
              日期(月):
              <el-input v-model="editFormchailvfeisub.datemonth" style="width: 10%"></el-input>
              日期(日):
              <el-input v-model="editFormchailvfeisub.dateday" style="width: 10%"></el-input>
              起始地点:
              <el-input v-model="editFormchailvfeisub.addressbegin" style="width: 10%"></el-input>
              到达终点:
              <el-input v-model="editFormchailvfeisub.addressend" style="width: 10%"></el-input>
              天数:
              <el-input v-model="editFormchailvfeisub.days" style="width: 10%"></el-input>
            </div>
          </div>
          <div class="productdata1">
            <div class="productdata2">
              火车/机票:
              <el-input v-model="editFormchailvfeisub.huochejipiao" style="width: 10%"></el-input>
              交通费:
              <el-input v-model="editFormchailvfeisub.jiaotongfei" style="width: 10%"></el-input>
              住宿费:
              <el-input v-model="editFormchailvfeisub.zhusufei" style="width: 10%"></el-input>
              补贴:
              <el-input v-model="editFormchailvfeisub.butie" style="width: 10%"></el-input>
              其他:
              <el-input v-model="editFormchailvfeisub.qita" style="width: 10%"></el-input>
              <el-button type="text" @click="clickaddchailvfeisub()">增加</el-button>
            </div>
          </div>
        </el-form-item>
        <el-form-item class="addAdminFormLLL">
          <label slot="label">
            <span style="color: #FF0000;">明细记录(必填)</span>
          </label>
          <el-card v-for="item,index in editFormchailvfei.chailvfeisub" :key="index">
            <li>日期(月)：{{item.datemonth}}；日期(日)：{{item.dateday}}；起始地点：{{item.addressbegin}}；到达终点：{{item.addressend}}；天数：{{item.days}}</li>
            <li>火车/机票：{{item.huochejipiao}}；交通费：{{item.jiaotongfei}}；住宿费：{{item.zhusufei}}；补贴：{{item.butie}}；其他：{{item.qita}}；小计：{{item.xiaoji}}</li>
            <el-button type="text" @click="clickdeletechailvfeisub(index)">删除</el-button>
          </el-card>
        </el-form-item>
        <el-form-item class="addAdminForm">
          <label slot="label">
            <span style="color: #FF0000;">金额(必填)</span>
          </label>
          <el-input v-model="editFormchailvfei.money" disabled></el-input>
        </el-form-item>
        <el-form-item label="预支(可选)" class="addAdminForm">
          <el-input v-model="editFormchailvfei.ccyuzhi"></el-input>
        </el-form-item>
        <el-form-item label="退/补(可选)" class="addAdminForm">
          <el-input v-model="editFormchailvfei.cctuibu"></el-input>
        </el-form-item>
        <el-form-item label="备注(可选)" class="addAdminForm">
          <el-input v-model="editFormchailvfei.beizhu"></el-input>
        </el-form-item>
        <el-form-item label="附件(可选)" class="addAdminForm">
          <TencentyunCosUploadMultiImgOrPdf ref="MultiImgOrPdf" @change="addTencentyunCosUploadMultiImgOrPdf"></TencentyunCosUploadMultiImgOrPdf>
          默认采用上次的附件，如果附件有改动，请把所有附件都重新上传。
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import TencentyunCosUploadMultiImgOrPdf from '@/components/TencentyunCosUploadMultiImgOrPdf.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadMultiImgOrPdf
  },
  data () {
    return {
      editFormchailvfei: {
        id: 0,
        reason: '',
        ccdaybegin: '',
        ccdayend: '',
        ccdays: '',
        ccattachmentnum: '',
        chailvfeisub: [],
        money: 0,
        ccyuzhi: '',
        cctuibu: '',
        beizhu: '',
        attachment: '',
        orderid: ''
      },
      editFormchailvfeisub: {
        datemonth: '',
        dateday: '',
        addressbegin: '',
        addressend: '',
        days: '',
        huochejipiao: 0,
        jiaotongfei: 0,
        zhusufei: 0,
        butie: 0,
        qita: 0,
        xiaoji: 0
      }
    }
  },
  mounted () {

  },
  methods: {
    LoadData (row) {
      console.log(row)
      this.editFormchailvfei.id = row.Id
      this.editFormchailvfei.reason = row.Reason
      this.editFormchailvfei.ccdaybegin = row.Ccdaybegin
      this.editFormchailvfei.ccdayend = row.Ccdayend
      this.editFormchailvfei.ccdays = row.Ccdays
      this.editFormchailvfei.ccattachmentnum = row.Ccattachmentnum
      this.editFormchailvfei.chailvfeisub = []
      this.editFormchailvfei.money = row.Money
      this.editFormchailvfei.ccyuzhi = row.Ccyuzhi
      this.editFormchailvfei.cctuibu = row.Cctuibu
      this.editFormchailvfei.beizhu = row.Beizhu
      this.editFormchailvfei.attachment = row.Attachment
      this.editFormchailvfei.orderid = row.Orderid
      this.apiGetShenPiNewFyBxChaiLvSubList(row.Orderid)

      this.$refs.MultiImgOrPdf.cleardata()
    },
    clickaddchailvfeisub () {
      if (this.editFormchailvfei.chailvfeisub.length >= 6) {
        Vue.prototype.FunAlertMsg('明细最多6条')
        return
      }
      if (this.editFormchailvfeisub.datemonth.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入日期(月)')
        return
      }
      if (this.editFormchailvfeisub.dateday.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入日期(日)')
        return
      }
      if (this.editFormchailvfeisub.addressbegin.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入起始地点')
        return
      }
      if (this.editFormchailvfeisub.addressend.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入到达终点')
        return
      }
      if (this.editFormchailvfeisub.days.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入天数')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfeisub.huochejipiao)) {
        Vue.prototype.FunAlertMsg('请输入火车/机票')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfeisub.jiaotongfei)) {
        Vue.prototype.FunAlertMsg('请输入交通费')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfeisub.zhusufei)) {
        Vue.prototype.FunAlertMsg('请输入住宿费')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfeisub.butie)) {
        Vue.prototype.FunAlertMsg('请输入补贴')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfeisub.qita)) {
        Vue.prototype.FunAlertMsg('请输入其他')
        return
      }
      this.editFormchailvfeisub.xiaoji = parseFloat(this.editFormchailvfeisub.huochejipiao) + parseFloat(this.editFormchailvfeisub.jiaotongfei) + parseFloat(this.editFormchailvfeisub.zhusufei) + parseFloat(this.editFormchailvfeisub.butie) + parseFloat(this.editFormchailvfeisub.qita)

      this.editFormchailvfei.chailvfeisub.push({
        datemonth: this.editFormchailvfeisub.datemonth,
        dateday: this.editFormchailvfeisub.dateday,
        addressbegin: this.editFormchailvfeisub.addressbegin,
        addressend: this.editFormchailvfeisub.addressend,
        days: this.editFormchailvfeisub.days,
        huochejipiao: parseFloat(this.editFormchailvfeisub.huochejipiao),
        jiaotongfei: parseFloat(this.editFormchailvfeisub.jiaotongfei),
        zhusufei: parseFloat(this.editFormchailvfeisub.zhusufei),
        butie: parseFloat(this.editFormchailvfeisub.butie),
        qita: parseFloat(this.editFormchailvfeisub.qita),
        xiaoji: this.editFormchailvfeisub.xiaoji
      })
      this.countchailvfeiMoney()
    },
    clickdeletechailvfeisub (index) {
      var buflist = []
      for (var j = 0, len = this.editFormchailvfei.chailvfeisub.length; j < len; j++) {
        if (index != j) {
          buflist.push(this.editFormchailvfei.chailvfeisub[j])
        }
      }
      this.editFormchailvfei.chailvfeisub = buflist
      this.countchailvfeiMoney()
    },
    countchailvfeiMoney () {
      this.editFormchailvfei.money = 0
      for (var j = 0, len = this.editFormchailvfei.chailvfeisub.length; j < len; j++) {
        this.editFormchailvfei.money += this.editFormchailvfei.chailvfeisub[j].xiaoji
      }
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      if (this.editFormchailvfei.reason.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差事由')
        return
      }
      if (this.editFormchailvfei.ccdaybegin.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差日期起')
        return
      }
      if (this.editFormchailvfei.ccdayend.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入出差日期讫')
        return
      }
      if (this.editFormchailvfei.ccdays.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入总天数')
        return
      }
      if (this.editFormchailvfei.ccattachmentnum.length <= 0) {
        Vue.prototype.FunAlertMsg('请输入附件张数')
        return
      }
      if (this.editFormchailvfei.chailvfeisub.length < 1) {
        Vue.prototype.FunAlertMsg('请填写明细')
        return
      }
      if (!Vue.prototype.FunCheckNumber(this.editFormchailvfei.money)) {
        Vue.prototype.FunAlertMsg('请输入金额')
      }
      this.apiEditShenPiNewFyBxChaiLv2()
    },
    addTencentyunCosUploadMultiImgOrPdf (url) {
      this.editFormchailvfei.attachment = url
    },
    apiGetShenPiNewFyBxChaiLvSubList: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetShenPiNewFyBxChaiLvSubList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            var dataList = response.data.List
            for (var i = 0; i < dataList.length - 1; i++) {
              that.editFormchailvfei.chailvfeisub.push({
                datemonth: dataList[i].Datemonth,
                dateday: dataList[i].Dateday,
                addressbegin: dataList[i].Addressbegin,
                addressend: dataList[i].Addressend,
                days: dataList[i].Days,
                huochejipiao: parseFloat(dataList[i].Huochejipiao),
                jiaotongfei: parseFloat(dataList[i].Jiaotongfei),
                zhusufei: parseFloat(dataList[i].Zhusufei),
                butie: parseFloat(dataList[i].Butie),
                qita: parseFloat(dataList[i].Qita),
                xiaoji: parseFloat(dataList[i].Xiaoji)
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditShenPiNewFyBxChaiLv2: function () {
      var bufchailvfeisub = []
      var bufhuochejipiao = 0
      var bufjiaotongfei = 0
      var bufzhusufei = 0
      var bufbutie = 0
      var bufqita = 0
      var bufxiaoji = 0
      for (var j = 0, len = this.editFormchailvfei.chailvfeisub.length; j < len; j++) {
        bufhuochejipiao += this.editFormchailvfei.chailvfeisub[j].huochejipiao
        bufjiaotongfei += this.editFormchailvfei.chailvfeisub[j].jiaotongfei
        bufzhusufei += this.editFormchailvfei.chailvfeisub[j].zhusufei
        bufbutie += this.editFormchailvfei.chailvfeisub[j].butie
        bufqita += this.editFormchailvfei.chailvfeisub[j].qita
        bufxiaoji += this.editFormchailvfei.chailvfeisub[j].xiaoji
        bufchailvfeisub.push(this.editFormchailvfei.chailvfeisub[j])
      }
      bufchailvfeisub.push({
        datemonth: '0',
        dateday: '0',
        addressbegin: '0',
        addressend: '0',
        days: '0',
        huochejipiao: bufhuochejipiao,
        jiaotongfei: bufjiaotongfei,
        zhusufei: bufzhusufei,
        butie: bufbutie,
        qita: bufqita,
        xiaoji: bufxiaoji
      })

      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: that.editFormchailvfei.id,
        reason: that.editFormchailvfei.reason,
        ccdaybegin: that.editFormchailvfei.ccdaybegin,
        ccdayend: that.editFormchailvfei.ccdayend,
        ccdays: that.editFormchailvfei.ccdays,
        ccattachmentnum: that.editFormchailvfei.ccattachmentnum,
        chailvfeisub: JSON.stringify(bufchailvfeisub),
        money: that.editFormchailvfei.money,
        ccyuzhi: that.editFormchailvfei.ccyuzhi,
        cctuibu: that.editFormchailvfei.cctuibu,
        beizhu: that.editFormchailvfei.beizhu,
        attachment: that.editFormchailvfei.attachment,
        orderid: that.editFormchailvfei.orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditShenPiNewFyBxChaiLv2, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
